var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 400,
    viewBox: "0 0 365 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2252_14145)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.823 0.088821C176.261 -2.1054 201.97 36.8579 230.426 61.2082C255.143 82.3594 274.07 106.911 293.826 132.73C319.544 166.341 360.142 193.426 363.821 235.539C367.629 279.145 344.382 323.101 313.139 353.858C282.821 383.704 239.374 399.688 196.765 399.997C158.641 400.273 120.769 382.51 94.0048 355.444C71.7027 332.891 70.4875 298.135 65.1644 266.915C62.081 248.83 78.1236 229.527 69.7509 213.192C54.1186 182.692 4.02419 174.23 0.212755 140.192C-3.08234 110.765 33.0336 92.6369 53.8909 71.5549C80.4435 44.7163 101.074 2.30129 138.823 0.088821Z",
    fill: "#081725"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2252_14145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.1641,
    y: 116.172,
    width: 128.053,
    height: 52.8053,
    rx: 10.5611,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2252_14145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.544 116.172H56.8296C53.1462 116.172 50.1602 119.127 50.1602 122.773V162.376C50.1602 166.022 53.1462 168.977 56.8296 168.977H171.544C175.227 168.977 178.213 166.022 178.213 162.376V122.773C178.213 119.127 175.227 116.172 171.544 116.172Z",
    fill: "#989D99"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2252_14145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.858 130.691H66.1774C63.9674 130.691 62.1758 132.465 62.1758 134.652C62.1758 136.839 63.9674 138.612 66.1774 138.612H100.858C103.068 138.612 104.86 136.839 104.86 134.652C104.86 132.465 103.068 130.691 100.858 130.691Z",
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.868 143.893H66.1774C63.9674 143.893 62.1758 145.666 62.1758 147.853C62.1758 150.04 63.9674 151.813 66.1774 151.813H124.868C127.078 151.813 128.87 150.04 128.87 147.853C128.87 145.666 127.078 143.893 124.868 143.893Z",
    fill: "#E5E5D6"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2252_14145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.1641,
    y: 58.0859,
    width: 128.053,
    height: 52.8053,
    rx: 10.5611,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2252_14145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.544 58.0859H56.8296C53.1462 58.0859 50.1602 61.0412 50.1602 64.6866V104.291C50.1602 107.936 53.1462 110.891 56.8296 110.891H171.544C175.227 110.891 178.213 107.936 178.213 104.291V64.6866C178.213 61.0412 175.227 58.0859 171.544 58.0859Z",
    fill: "#989D99"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2252_14145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.854 72.6055H66.1735C63.9635 72.6055 62.1719 74.3786 62.1719 76.5659C62.1719 78.7531 63.9635 80.5263 66.1735 80.5263H100.854C103.065 80.5263 104.856 78.7531 104.856 76.5659C104.856 74.3786 103.065 72.6055 100.854 72.6055Z",
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.864 85.8066H66.1735C63.9635 85.8066 62.1719 87.5798 62.1719 89.767C62.1719 91.9543 63.9635 93.7274 66.1735 93.7274H124.864C127.074 93.7274 128.866 91.9543 128.866 89.767C128.866 87.5798 127.074 85.8066 124.864 85.8066Z",
    fill: "#E5E5D6"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 50.166,
    y: 174.258,
    width: 264.026,
    height: 168.977,
    rx: 10.5611,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.6483,
    cy: 192.74,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 184.819,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 194.72,
    width: 223.102,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.6483,
    cy: 219.142,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 211.222,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 221.123,
    width: 223.102,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.6483,
    cy: 245.545,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 237.624,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 247.525,
    width: 223.102,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.6483,
    cy: 271.948,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 264.027,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 273.928,
    width: 223.102,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.6483,
    cy: 298.35,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 290.429,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 300.33,
    width: 223.102,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.6483,
    cy: 324.753,
    r: 7.92079,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 316.832,
    width: 31.6832,
    height: 5.94059,
    rx: 2.9703,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5293,
    y: 326.733,
    width: 223.102,
    height: 5.94059,
    rx: 2.9703,
    fill: "#E5E5D6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.178,
    y: 58.0859,
    width: 132.013,
    height: 110.891,
    rx: 10.5611,
    fill: "#989D99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.266 113.53C273.266 136.131 254.944 154.454 232.342 154.454C209.74 154.454 191.418 136.131 191.418 113.53C191.418 90.9278 209.74 72.6055 232.342 72.6055C254.944 72.6055 273.266 90.9278 273.266 113.53ZM201.649 113.53C201.649 130.481 215.391 144.223 232.342 144.223C249.293 144.223 263.035 130.481 263.035 113.53C263.035 96.5782 249.293 82.8365 232.342 82.8365C215.391 82.8365 201.649 96.5782 201.649 113.53Z",
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.266 113.53C273.266 105.539 270.927 97.7233 266.537 91.0466C262.147 84.3699 255.899 79.1245 248.563 75.9573C241.227 72.7902 233.124 71.84 225.254 73.224C217.384 74.6079 210.092 78.2655 204.276 83.7454C198.461 89.2253 194.377 96.2878 192.528 104.062C190.68 111.835 191.147 119.98 193.873 127.491C196.599 135.002 201.465 141.551 207.869 146.33C214.273 151.108 221.936 153.907 229.913 154.381L230.52 144.169C224.538 143.813 218.79 141.713 213.987 138.13C209.184 134.546 205.535 129.634 203.49 124.001C201.446 118.368 201.095 112.259 202.482 106.429C203.868 100.598 206.931 95.3013 211.293 91.1914C215.654 87.0815 221.124 84.3383 227.026 83.3004C232.928 82.2624 239.005 82.975 244.508 85.3504C250.01 87.7257 254.696 91.6598 257.988 96.6673C261.281 101.675 263.035 107.537 263.035 113.53H273.266Z",
    fill: "#666E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.266 113.53C273.266 107.5 271.934 101.546 269.365 96.0911C266.796 90.6366 263.053 85.8172 258.404 81.9775C253.756 78.1378 248.316 75.3726 242.475 73.8798C236.633 72.3869 230.534 72.2032 224.613 73.3419C218.693 74.4805 213.097 76.9133 208.226 80.4664C203.354 84.0194 199.329 88.6049 196.436 93.8948C193.543 99.1848 191.855 105.049 191.492 111.067C191.129 117.085 192.101 123.109 194.337 128.709L203.838 124.914C202.161 120.714 201.433 116.196 201.705 111.683C201.977 107.169 203.243 102.771 205.412 98.8035C207.582 94.836 210.601 91.3969 214.255 88.7322C217.908 86.0674 222.105 84.2428 226.546 83.3888C230.986 82.5348 235.561 82.6726 239.942 83.7922C244.323 84.9119 248.402 86.9857 251.889 89.8655C255.375 92.7453 258.182 96.3598 260.109 100.451C262.036 104.542 263.035 109.008 263.035 113.53H273.266Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.266 113.53C273.266 105.107 270.667 96.8891 265.824 89.998C260.981 83.1069 254.129 77.878 246.205 75.0249C238.28 72.1717 229.668 71.8334 221.543 74.0559C213.419 76.2785 206.178 80.9537 200.81 87.4436L208.693 93.9651C212.719 89.0977 218.15 85.5912 224.243 83.9243C230.336 82.2574 236.795 82.5112 242.739 84.651C248.683 86.7909 253.821 90.7125 257.454 95.8809C261.086 101.049 263.035 107.212 263.035 113.53H273.266Z",
    fill: "#B2B5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.266 113.53C273.266 106.636 271.525 99.8548 268.204 93.8142L259.239 98.7431C261.729 103.273 263.035 108.36 263.035 113.53H273.266Z",
    fill: "#CBCDC2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.187,
    cy: 80.528,
    r: 2.64026,
    fill: "#CBCDC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.468,
    y: 79.208,
    width: 15.8416,
    height: 2.64026,
    rx: 1.32013,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.187,
    cy: 88.4489,
    r: 2.64026,
    fill: "#B2B5AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.468,
    y: 87.1289,
    width: 15.8416,
    height: 2.64026,
    rx: 1.32013,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.187,
    cy: 96.3698,
    r: 2.64026,
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.468,
    y: 95.0498,
    width: 15.8416,
    height: 2.64026,
    rx: 1.32013,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.187,
    cy: 104.29,
    r: 2.64026,
    fill: "#666E71"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.468,
    y: 102.97,
    width: 15.8416,
    height: 2.64026,
    rx: 1.32013,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.187,
    cy: 112.211,
    r: 2.64026,
    fill: "#4C565D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.468,
    y: 110.891,
    width: 15.8416,
    height: 2.64026,
    rx: 1.32013,
    fill: "#4C565D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2252_14145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 364.228,
    height: 400,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2252_14145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.1641,
    y: 116.172,
    width: 128.053,
    height: 52.8053,
    rx: 10.5611,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2252_14145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.1621,
    y: 116.172,
    width: 128.053,
    height: 52.8053,
    rx: 10.6275,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2252_14145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.6942,
    height: 25.0825,
    fill: "white",
    transform: "translate(62.1777 130.693)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2252_14145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.1641,
    y: 58.0859,
    width: 128.053,
    height: 52.8053,
    rx: 10.5611,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2252_14145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.1621,
    y: 58.0859,
    width: 128.053,
    height: 52.8053,
    rx: 10.6275,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2252_14145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.6942,
    height: 25.0825,
    fill: "white",
    transform: "translate(62.1719 72.6074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsEmptyState);
export default __webpack_public_path__ + "static/media/stats-empty-state.19e5b56a5d81eee9f1ffa5f493c1ab62.svg";
export { ForwardRef as ReactComponent };